<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import Button from '~/components/ui/Button.vue'

const { uri } = defineProps<{ uri: string }>()

const { t } = useI18n()
</script>

<template>
  <Button
    :to="{ path: uri }"
    shade="light"
    size="lg"
    v-bind="$attrs"
  >
    {{ t('filters.toLegacySubject') }}
  </Button>
</template>
